import UserDialog from './user';

export default () => <UserDialog />;
